import React from 'react';
import profilePic from '../../../../assets/images/profile_pic_1.png';

var Template_2 = function Template_2(props) {
    var defaulValues = {};
    var values = props.values,
        validWebsiteURL = props.validWebsiteURL,
        validImageURL = props.validImageURL,
        validEmail = props.validEmail,
        fetchingTweets = props.fetchingTweets;


    var hasValues = Object.values(values).some(function (val, index) {
        return val && val.length > 0 || typeof val === 'boolean';
    });

    var fontSizeName = values.fontSizeName ? values.fontSizeName + 'px' : '11px';
    var fontStyleName = values.fontStyleName ? values.fontStyleName : '';
    var fontWeightName = values.fontWeightName ? values.fontWeightName : '';
    var fontLineHeightName = values.fontLineHeightName ? values.fontLineHeightName + 'px' : '22px';
    var nameColor = values.selectedColorName ? values.selectedColorName : '#000';

    var fontSizeTitle = values.fontSizeTitle ? values.fontSizeTitle + 'px' : '11px';
    var fontStyleTitle = values.fontStyleTitle ? values.fontStyleTitle : '';
    var fontWeightTitle = values.fontWeightTitle ? values.fontWeightTitle : '';
    var fontLineHeightTitle = values.fontLineHeightTitle ? values.fontLineHeightTitle + 'px' : '22px';
    var titleColor = values.selectedColorTitle ? values.selectedColorTitle : '#000';

    var fontSizeAddress = values.fontSizeAddress ? values.fontSizeAddress + 'px' : '11px';
    var addressColor = values.selectedColorAddress ? values.selectedColorAddress : '#000';
    var addressTextOpacity = values.addressTextOpacity ? values.addressTextOpacity : 1;

    var dividerColor = values.selectedColorDivider ? values.selectedColorDivider : '#000';

    var fontFamily = values.activeFontFamily ? values.activeFontFamily : '';
    var fontSize = values.fontSize ? values.fontSize + 'px' : '11px';
    var templateColor = values.selectedTemplateColor ? values.selectedTemplateColor : '#000';
    var textColor = values.selectedColor ? values.selectedColor : '#000';

    var fixLink = values.website ? values.website : '';
    if (fixLink && !fixLink.startsWith("http://") && !fixLink.startsWith("https://")) {
        fixLink = "https://" + fixLink;
    } else if (fixLink && fixLink.startsWith("http://")) {
        // Do nothing, since the link already starts with "http://"
    }

    if (!hasValues) {
        defaulValues = {
            name: 'Michael Jonshon',
            title: 'Freelancer Photographer',
            address: 'ex: 649 E Girard Ave Englewood, CO 80113',
            picture: profilePic,
            mobile: '001 123 456 789',
            telephone: '002 222 222 222',
            fax: '003 333 333 333',
            website: 'www.cortab.com',
            email: 'michael.jonshon@cortab.com',
            linkedin: '#',
            skype: '#',
            facebook: '#',
            whatsapp: '#',
            twitterLink: '#',
            instagramLink: '#'
        };
    }

    var whatsappCode = values.phoneCode ? values.phoneCode.substring(1) : defaulValues.phoneCode;

    return React.createElement(
        'div',
        { className: 'template2', style: { "maxWidth": "400px", textDecoration: "none", display: "flex" } },
        React.createElement(
            'div',
            { style: values.linkedin || values.facebook || values.twitterLink || values.whatsapp || values.instagramLink ? { borderRight: '2px solid ' + dividerColor, paddingLeft: '10px', paddingRight: '10px', minHeight: '185px', height: '185px', marginRight: '10px' } : { paddingLeft: '10px', paddingRight: '10px', minHeight: '185px', height: '185px', marginRight: '10px' } },
            (values.linkedin || defaulValues.linkedin) && React.createElement(
                'a',
                { href: 'https://www.linkedin.com/in/' + (values.linkedin ? values.linkedin : defaulValues.linkedin), target: '_blank', style: { display: 'flex' } },
                React.createElement('img', { style: { width: "25px", marginTop: "3px", marginBottom: "3px" }, src: 'https://bluemail.me/img/signature-editor/linkedin.png' })
            ),
            (values.facebook || defaulValues.facebook) && React.createElement(
                'a',
                { href: 'https://www.facebook.com/' + (values.facebook ? values.facebook : defaulValues.facebook), target: '_blank', style: { display: 'flex' } },
                React.createElement('img', { style: { width: "25px", marginTop: "3px", marginBottom: "3px" }, src: 'https://bluemail.me/img/signature-editor/facebook.png' })
            ),
            (values.twitterLink || defaulValues.twitterLink) && React.createElement(
                'a',
                { href: 'https://twitter.com/' + (values.twitterLink ? values.twitterLink : defaulValues.twitterLink), target: '_blank', style: { display: 'flex' } },
                React.createElement('img', { style: { width: "25px", marginTop: "3px", marginBottom: "3px" }, src: 'https://bluemail.me/img/signature-editor/twitter.png' })
            ),
            (values.whatsapp || defaulValues.whatsapp) && (values.phoneCode && values.phoneCode.length > 1 || defaulValues.phoneCode) && React.createElement(
                'a',
                { href: 'https://api.whatsapp.com/send?phone=' + (values.phoneCode ? whatsappCode : defaulValues.phoneCode) + (values.whatsapp ? values.whatsapp : defaulValues.whatsapp), target: '_blank', style: { display: 'flex' } },
                React.createElement('img', { style: { width: "25px", marginTop: "3px", marginBottom: "3px" }, src: 'https://bluemail.me/img/signature-editor/whatsapp.png' })
            ),
            (values.tiktok || defaulValues.tiktok) && React.createElement(
                'a',
                { href: 'https://www.tiktok.com/@' + (values.tiktok ? values.tiktok : defaulValues.tiktok), target: '_blank', style: { display: 'flex' } },
                React.createElement('img', { style: { width: "25px", marginTop: "3px", marginBottom: "3px" }, src: 'https://bluemail.me/img/signature-editor/tiktok.png' })
            ),
            (values.instagramLink || defaulValues.instagramLink) && React.createElement(
                'a',
                { href: 'https://www.instagram.com/' + (values.instagramLink ? values.instagramLink : defaulValues.instagramLink), target: '_blank', style: { display: 'flex' } },
                React.createElement('img', { style: { width: "25px", marginTop: "3px", marginBottom: "3px" }, src: 'https://bluemail.me/img/signature-editor/instagram.png' })
            )
        ),
        React.createElement(
            'div',
            { style: { maxWidth: '255px', width: '255px', paddingRight: '10px', minHeight: '185px' } },
            React.createElement(
                'div',
                { style: { marginBottom: '10px' } },
                React.createElement(
                    'div',
                    { style: { "textAlign": "left" } },
                    React.createElement(
                        'span',
                        { style: { fontFamily: fontFamily, fontSize: fontSizeName, color: nameColor, fontStyle: fontStyleName, fontWeight: fontWeightName, lineHeight: fontLineHeightName } },
                        values && values.name ? values.name : defaulValues.name
                    )
                ),
                React.createElement(
                    'div',
                    { style: { "marginBottom": "5px", "textAlign": "left" } },
                    React.createElement(
                        'span',
                        { style: { fontFamily: fontFamily, fontSize: fontSizeTitle, color: titleColor, fontStyle: fontStyleTitle, fontWeight: fontWeightTitle, lineHeight: fontLineHeightTitle } },
                        values && values.title ? values.title : defaulValues.title
                    )
                ),
                React.createElement(
                    'div',
                    { style: { "marginBottom": "5px", "textAlign": "left", "fontWeight": "normal" } },
                    React.createElement(
                        'span',
                        { style: { fontFamily: fontFamily, fontSize: fontSizeAddress, color: addressColor, opacity: addressTextOpacity } },
                        values && values.address ? values.address : defaulValues.address
                    )
                )
            ),
            values && (values.mobile || defaulValues.mobile) && React.createElement(
                'div',
                { style: { "whiteSpace": "nowrap", "textAlign": "left" } },
                React.createElement(
                    'span',
                    { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, fontWeight: 'bold' } },
                    'Mobile:'
                ),
                React.createElement(
                    'span',
                    { style: { "marginLeft": "5px" } },
                    React.createElement(
                        'a',
                        { href: 'tel:' + (values.mobile || defaulValues.mobile) },
                        React.createElement(
                            'span',
                            { style: { fontFamily: fontFamily, fontSize: fontSize, color: textColor } },
                            values.mobile || defaulValues.mobile
                        )
                    )
                )
            ),
            values && (values.telephone || defaulValues.telephone) && React.createElement(
                'div',
                { style: { "whiteSpace": "nowrap", "textAlign": "left" } },
                React.createElement(
                    'span',
                    { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, fontWeight: 'bold' } },
                    'Tel:'
                ),
                React.createElement(
                    'span',
                    { style: { "marginLeft": "5px" } },
                    React.createElement(
                        'a',
                        { href: 'tel:' + (values.telephone || defaulValues.telephone) },
                        React.createElement(
                            'span',
                            { style: { fontFamily: fontFamily, fontSize: fontSize, color: textColor } },
                            values.telephone || defaulValues.telephone
                        )
                    )
                )
            ),
            validWebsiteURL !== true && values && (values.website || defaulValues.website) && React.createElement(
                'div',
                { style: { "whiteSpace": "nowrap", "textAlign": "left" } },
                React.createElement(
                    'span',
                    { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, fontWeight: 'bold' } },
                    'Site:'
                ),
                React.createElement(
                    'span',
                    { style: { "marginLeft": "5px" } },
                    React.createElement(
                        'a',
                        { style: { fontFamily: fontFamily, fontSize: fontSize }, href: fixLink || defaulValues.website, target: '_blank' },
                        React.createElement(
                            'span',
                            { style: { fontFamily: fontFamily, fontSize: fontSize, color: textColor } },
                            values.website || defaulValues.website
                        )
                    )
                )
            ),
            validEmail !== true && values && (values.email || defaulValues.email) && React.createElement(
                'div',
                { style: { "whiteSpace": "nowrap", "textAlign": "left" } },
                React.createElement(
                    'span',
                    { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, fontWeight: 'bold' } },
                    'Email:'
                ),
                React.createElement(
                    'span',
                    { style: { "marginLeft": "5px" } },
                    React.createElement(
                        'a',
                        { href: "mailto:" + (values.email || defaulValues.email) },
                        React.createElement(
                            'span',
                            { style: { fontFamily: fontFamily, fontSize: fontSize, color: textColor } },
                            values.email || defaulValues.email
                        )
                    )
                )
            )
        ),
        React.createElement(
            'table',
            { style: values && (values.picture_base64 || values.picture_link || defaulValues.picture) ? { "width": "113px", "min-height": '185px', "height": '185px', "min-width": '93px', "padding-right": '10px' } : { "width": "113px", "min-height": '185px', "height": '185px', "min-width": '85px', "margin-right": '10px', "margin-left": '10px', "padding-right": '10px' } },
            React.createElement(
                'tr',
                null,
                React.createElement(
                    'td',
                    { style: { "vertical-align": "top", "height": "50%" } },
                    React.createElement(
                        'div',
                        { style: { verticalAlign: 'top', textAlign: 'center' } },
                        (values.picture_base64 || defaulValues.picture) && !values.picture_link ? React.createElement('img', { style: { width: values.size ? values.size + 'px' : '60px', height: values.size ? values.size + 'px' : '60px', borderRadius: '50%', marginRight: '10px' }, src: defaulValues.picture ? defaulValues.picture : values.picture_base64 }) : (values.picture_base64 || defaulValues.picture) && values.picture_link && validImageURL !== true ? React.createElement('img', { style: { width: values.size ? values.size + 'px' : '60px', height: values.size ? values.size + 'px' : '60px', borderRadius: '50%', marginRight: '10px' }, src: defaulValues.picture ? defaulValues.picture : values.picture_base64 }) : validImageURL !== true && values.picture_link && React.createElement('img', { style: { width: values.size ? values.size + 'px' : '60px', height: values.size ? values.size + 'px' : '60px', borderRadius: '50%', marginRight: '10px' }, src: values.picture_link })
                    )
                )
            ),
            React.createElement(
                'tr',
                null,
                React.createElement(
                    'td',
                    { style: { "vertical-align": "bottom", "height": "50%;" } },
                    values.checkSignature && React.createElement(
                        'div',
                        { style: { width: '100%', textAlign: 'center', minWidth: '90px' } },
                        React.createElement(
                            'a',
                            { className: 'getBlueMail', style: { color: '#1F6BF1', textDecoration: 'underline', fontSize: '14px' }, href: 'https://bluemail.me/download', target: '_blank' },
                            'Get BlueMail'
                        )
                    )
                )
            )
        )
    );
};

export default Template_2;


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/containers/app/Templates/2.js